import { render, staticRenderFns } from "./RevolutBankResultModal.vue?vue&type=template&id=7b17251c&scoped=true&"
import script from "./RevolutBankResultModal.vue?vue&type=script&lang=js&"
export * from "./RevolutBankResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17251c",
  null
  
)

export default component.exports